export const footerFormEn = {
    footerFormnameUp: "how to address you",
    footerFormnamePlaceholder: "Name",
    footerFormemailUp: "email",
    footerFormphoneUp: "phone",
    footerFormwhereUFrom: "where are you from",
    footerFormthemeUp: "subject of the message", 
    footerFormthemePlaceholder: "select a topic",
    footerFormmessageUp: "your message",
    footerFormmessagePlaceholder: "text",
    footerFormpolicy: "I consent to the processing of personal data and agree to the term",
    footerFormpolicyLink: "Personal data processing and Protection Policies",
    footerFormpolicyCheckbox: "I agree",
    footerFormerror: "incorrect data was entered",
    footerFormnameErrorLength: "The name must contain at least 2 letters",
    footerFormnameErrorCyrillic: "First/Last name must be in Cyrillic!",
    footerFormrequired: "required field",
    footerFormselect: "choose a direction",
    footerFormType: "organization type",
    footerFormCount: "select quantity",
    footerFormEmailPatternError: "Invalid mail format",
    footerFormPhonePatternError: "The phone number must consist of 11 digits",
    footerFormProducts: "products",
    footerFormImagine: "you represent the",
    footerFormCountOfHeads: "number of heads",
}

export const footerFormRu = {
    footerFormnameUp: "как к вам обращаться",
    footerFormnamePlaceholder: "Имя",
    footerFormemailUp: "электронная почта",
    footerFormphoneUp: "телефон",
    footerFormwhereUFrom: "откуда вы",
    footerFormthemeUp: "тема обращения", 
    footerFormthemePlaceholder: "выберите тему",
    footerFormmessageUp: "ваше сообщение",
    footerFormmessagePlaceholder: "текст",
    footerFormpolicy: "Я даю согласие на обработку персональных данных и соглашаюсь с условиями",
    footerFormpolicyLink: "Политики обработки и защиты персональных данных",
    footerFormpolicyCheckbox: "согласен",
    footerFormerror: "введены некорректные данные",
    footerFormnameErrorLength: "Имя должно содержать минимум 2 буквы",
    footerFormnameErrorCyrillic: "Имя/Фамилия должны быть на кириллице!",
    footerFormrequired: "обязательное поле",
    footerFormselect: "выберите направление",
    footerFormType: "тип организации",
    footerFormCount: "выберите количество",
    footerFormEmailPatternError: "Неверный формат почты",
    footerFormPhonePatternError: "Номер телефона должен состоять из 11 цифр",
    footerFormProducts: "продукция",
    footerFormImagine: "вы представляете",
    footerFormCountOfHeads: "количество голов",
}

export const footerFormCN = {
    footerFormnameUp: "如何称呼您",
    footerFormnamePlaceholder: "姓名",
    footerFormemailUp: "电子邮件",
    footerFormphoneUp: "电话",
    footerFormwhereUFrom: "您来自哪里",
    footerFormthemeUp: "咨询主题",
    footerFormthemePlaceholder: "选择主题",
    footerFormmessageUp: "您的消息",
    footerFormmessagePlaceholder: "文本",
    footerFormpolicy: "我同意处理个人数据并同意条款",
    footerFormpolicyLink: "个人数据处理和保护政策",
    footerFormpolicyCheckbox: "同意",
    footerFormerror: "输入了不正确的数据",
    footerFormnameErrorLength: "姓名必须至少包含2个字母",
    footerFormnameErrorCyrillic: "姓名/姓氏必须使用西里尔字母！",
    footerFormrequired: "必填字段",
    footerFormselect: "选择方向",
    footerFormType: "组织类型",
    footerFormCount: "选择数量",
    footerFormEmailPatternError: "电子邮件格式不正确",
    footerFormPhonePatternError: "电话号码必须由11位数字组成",
    footerFormProducts: "产品",
    footerFormImagine: "您代表什么",
    footerFormCountOfHeads: "头数",
}